import { useSubscribers } from "../../../../store/subscription/useSubscribers";

import { SubscriberController } from "../../../../services/controllers/subscription";

import { Alert } from "../../../../components/ui/Alert";

// details vem de: SubscriberController.findDetails → findSubscription(id) → API GET subscriptions/store/list/:id → setDetails()
export function AlertChangePlan() {
  const details = useSubscribers(st => st.data.details)

  const CSubscriber = SubscriberController();

  if (!details) return null

  const email = details.customer?.email?.trim?.() || ''
  const semEmail = !email
  const customerName = details.customer?.name?.fullName ?? details.customer?.name ?? ''

  return (
    <Alert.Root name={CSubscriber.changeSubscriptionPlanAlertName}>
      <Alert.Content>
        {semEmail ? (
          <>
            <Alert.Title>🚫 Não é possível enviar o link</Alert.Title>
            <p className="mb-10">
              Este cliente não possui e-mail cadastrado. Por isso, não é possível enviar o link.
            </p>
            <Alert.Actions>
              <Alert.Cancel>Voltar</Alert.Cancel>
            </Alert.Actions>
          </>
        ) : (
          <>
            <Alert.Title>Troca de Plano</Alert.Title>
            <Alert.Description>
              <span>Ao clicar em <strong className="highlight">Enviar</strong>, será enviada uma mensagem para o cliente {customerName}. O que irá acontecer:</span>
            </Alert.Description>
            <ul className="space-y-3 mb-10">
              <li>Cliente irá receber por Email um link para <strong className="highlight">trocar o plano da Assinatura</strong>.</li>
              <li>Quando entrar nesse link, o cliente deverá confirmar a solicitação da troca de plano.</li>
              <li>A troca é irreversível ate a próxima cobrança.</li>
              <li>O link expira em até 24 horas.</li>
              <p className="mb-3 font-medium text-lg">E-mail de envio: {email}</p>
            <br />
            <br />
            </ul>
            <Alert.Actions>
              <Alert.Cancel>Cancelar</Alert.Cancel>
              <Alert.Confirm
                onClick={() => CSubscriber.changeSubscriberPlan(false, true)}
              >
                Enviar Email
              </Alert.Confirm>
            </Alert.Actions>
          </>
        )}
      </Alert.Content>
    </Alert.Root>
  )
}
